export default __webpack_public_path__ + "static/media/330_business06-nl-mobile.8f210466.png";